module.exports = __webpack_public_path__ + "img/09_no.7212608d.svg";